import { render, staticRenderFns } from "./PortfolioOverview.vue?vue&type=template&id=912ece3c&scoped=true"
import script from "./PortfolioOverview.vue?vue&type=script&lang=ts"
export * from "./PortfolioOverview.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioOverview.vue?vue&type=style&index=0&id=912ece3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912ece3c",
  null
  
)

export default component.exports